var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99997 1.99994L7.29297 1.29294L7.99997 0.585938L8.70697 1.29294L7.99997 1.99994ZM8.99997 10.9999C8.99997 11.2652 8.89461 11.5195 8.70708 11.707C8.51954 11.8946 8.26519 11.9999 7.99997 11.9999C7.73475 11.9999 7.4804 11.8946 7.29286 11.707C7.10533 11.5195 6.99997 11.2652 6.99997 10.9999H8.99997ZM2.29297 6.29294L7.29297 1.29294L8.70697 2.70694L3.70697 7.70694L2.29297 6.29294ZM8.70697 1.29294L13.707 6.29294L12.293 7.70694L7.29297 2.70694L8.70697 1.29294ZM8.99997 1.99994V10.9999H6.99997V1.99994H8.99997Z",
    fill: "#363853"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 13V14C1 14.5304 1.21071 15.0391 1.58579 15.4142C1.96086 15.7893 2.46957 16 3 16H13C13.5304 16 14.0391 15.7893 14.4142 15.4142C14.7893 15.0391 15 14.5304 15 14V13",
    stroke: "#363853",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.48fe93a0ee1991dc482f1d356e8481bf.svg";
export { ForwardRef as ReactComponent };